import { Box, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IconButtonOutlined } from "../utils/IconButtonOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import React, { useEffect, useState } from "react";
interface SearchAndFilterProps {
  searchText: string;
  onSubmit: (searchQuery: string) => void;
  onCloseClick: () => void; // added this especially for the data layer
}

export const UserSearchBox = (props: SearchAndFilterProps) => {
  const { searchText, onSubmit, onCloseClick } = props;

  const [currentSearchText, setCurrentSearchText] = useState("");

  let submitSearch = () => {
    onSubmit(currentSearchText);
  };

  useEffect(() => {
    if (searchText === "") {
      setCurrentSearchText("");
    } else {
      setCurrentSearchText(searchText);
    }
  }, [searchText]);

  useEffect(() => {
    let delayedSearch = setTimeout(() => {
      onSubmit(currentSearchText);
    }, 1000);
    return () => clearTimeout(delayedSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSearchText]);

  let keyPress = (e: any) => {
    if (e.keyCode === 13) {
      submitSearch();
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: "16px" }}>
        <Box
          sx={{
            maxWidth: "448px",
            minWidth: "396px",
            backgroundColor: "#ffffff",
            height: "37px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
            padding: "8px",
            borderRadius: "15px",
            border: "2px solid #DEDEDE",
          }}>
          <SearchIcon sx={{ fontSize: "16px", margin: "3px 0px 3px 8px" }} />
          <InputBase
            onKeyDown={keyPress}
            value={currentSearchText}
            onChange={(e) => {
              setCurrentSearchText(e.target.value);
            }}
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search…"
            inputProps={{ "aria-label": "Search videos here" }}
          />
          {currentSearchText.length > 0 ? (
            <IconButtonOutlined
              sx={{
                width: "21px",
                height: "21px",
                border: "2px solid #5D5D5D !important",
                "&:hover": {
                  border: "2px solid #EE4069 !important",
                  backgroundColor: "transparent !important",
                },
              }}
              hover={
                <CloseRoundedIcon
                  style={{ width: "16px", height: "16px", color: "#EE4069" }}
                />
              }
              tooltipLabel="Clear current search"
              tooltipPlacement="bottom"
              onClick={() => {
                setCurrentSearchText("");
                onSubmit("");
                onCloseClick();
              }}>
              <CloseRoundedIcon
                style={{ width: "16px", height: "16px", color: "#5D5D5D" }}
              />
            </IconButtonOutlined>
          ) : null}
        </Box>
      </Box>
    </>
  );
};
